import { FocusedCard } from '@brokerbay/design-components';
import { MemberNumberState } from '@bb/users';
import { OnboardingController } from 'api';
import { message } from 'components';
import React from 'react';
import { AgentVerificationPageState } from '../../types';
import {
  AgentVerificationProps,
  AgentVerificationView as BaseAgentVerificationView,
} from '../common/AgentVerificationView';

export const OnboardingClaimView = () => {
  const claimProfileCall: AgentVerificationProps['claimProfileCall'] =
    async values => {
      let pageState: AgentVerificationPageState;
      const result = await OnboardingController.initiateClaimProfile({
        boardId: values.boardId,
        number: values.memberId,
      });

      if (result.state === MemberNumberState.active) {
        pageState = result.unclaimed ? 'verificationSent' : 'contactOffice';
      } else if (result.state === MemberNumberState.deactivated) {
        pageState = 'contactOffice';
      } else {
        pageState = 'contactSales';
      }
      return { error: '', pageState, result };
    };

  const resendVerificationCall: AgentVerificationProps['resendVerificationCall'] =
    async values => {
      const result = await OnboardingController.initiateClaimProfile({
        boardId: values.boardId,
        number: values.memberId,
      });

      if (!result.unclaimed) {
        return {
          error:
            'Profile is no longer unclaimed. Please start the process again.',
          result,
        };
      }
      message.success('Verification email has been sent.');
      return { result };
    };

  return (
    <FocusedCard>
      <BaseAgentVerificationView
        claimProfileCall={claimProfileCall}
        resendVerificationCall={resendVerificationCall}
      />
    </FocusedCard>
  );
};
